export default function SectionHeading({
  icon,
  eyebrow,
  title,
  subtitle,
  lang = "ar",
  theme = "dark",
  align = "start",
  compact = false,
}) {
  const dark = theme === "dark";
  const ar = lang === "ar";
  const arabicFont = ar ? "font-arabic" : "font-outfit";
  const alignClass =
    align === "center"
      ? "items-center text-center"
      : ar
      ? "items-end text-right sm:items-start sm:text-right"
      : "items-start text-left";
  const innerAlign = align === "center" ? "mx-auto" : "";

  return (
    <div className={`flex flex-col ${alignClass}`}>
      {/* Pill badge eyebrow */}
      <div
        data-testid="section-eyebrow"
        className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[10px] sm:text-[11px] font-extrabold uppercase tracking-[0.2em] ${
          dark
            ? "bg-[#18c98f]/12 border-[#18c98f]/40 text-[#18c98f]"
            : "bg-[#18c98f]/10 border-[#18c98f]/40 text-[#12a777]"
        } ${arabicFont}`}
      >
        {icon ? <span className="shrink-0">{icon}</span> : null}
        <span>{eyebrow}</span>
      </div>

      {/* Title with gradient highlight */}
      <h2
        data-testid="section-title"
        className={`${compact ? "mt-1.5 text-xl sm:text-2xl" : "mt-4 text-3xl sm:text-4xl lg:text-5xl"} font-extrabold tracking-tight leading-[1.15] max-w-3xl ${arabicFont} ${innerAlign} ${
          dark ? "text-white" : "text-[#182138]"
        }`}
      >
        {title}
      </h2>

      {/* Accent gradient underline */}
      {!compact && (
        <div
          aria-hidden="true"
          className={`mt-4 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#18c98f] to-transparent`}
        />
      )}

      {subtitle ? (
        <p
          data-testid="section-subtitle"
          className={`${compact ? "mt-1.5 text-[11px] sm:text-xs" : "mt-5 text-sm sm:text-base"} max-w-2xl leading-relaxed ${
            dark ? "text-white/70" : "text-[#2d2c35]/75"
          } ${arabicFont} ${innerAlign}`}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}

/**
 * Smooth gradient divider between sections — soft fade from accent to transparent on top.
 * Place at the very top of each section replacing the hard `border-t`.
 */
export function SectionDivider({ theme = "dark" }) {
  const dark = theme === "dark";
  return (
    <div
      aria-hidden="true"
      className={`h-px w-full bg-gradient-to-r from-transparent via-[#18c98f]/40 to-transparent ${
        dark ? "opacity-70" : "opacity-60"
      }`}
    />
  );
}
